import React, { useState } from 'react';
import './FaqSection.css';

const faqItems = [
	{
		question: 'Wie kann ich Beta-Tester werden?',
		answer: 'Du kannst dich ganz einfach über den Button am Ende der Seite anmelden und erhältst dann Zugang zur Beta-Version von Erledix.',
	},
	{
		question: 'Ist Erledix wirklich kostenlos in der Beta?',
		answer: 'Ja, während der Beta-Phase ist die Nutzung komplett kostenlos – inklusive lebenslangem Premium-Zugang für Beta-Tester!',
	},
	{
		question: 'Wie sicher sind meine Daten?',
		answer: 'Datenschutz hat bei uns höchste Priorität. Alle deine Daten werden verschlüsselt gespeichert und nicht an Dritte weitergegeben.',
	},
	{
		question: 'Kann ich Erledix auch mit mehreren Familienmitgliedern nutzen?',
		answer: 'Absolut! Erledix ist speziell dafür entwickelt, Familien bei der Organisation zu unterstützen und Aufgaben gerecht zu verteilen.',
	},
	{
		question: 'Können sich mehrere Nutzer ein Endgerät teilen?',
		answer: 'Ja, mehrere Nutzer können sich problemlos ein Gerät teilen. Jeder Nutzer hat sein eigenes Profil und individuelle Aufgabenverwaltung.',
	},
	{
		question: 'Müssen die Kinder sich mit einer E-Mail registrieren?',
		answer: 'Nein, Kinder können ohne E-Mail-Adresse ein Profil nutzen. Die Registrierung ist einfach und kinderfreundlich gestaltet.',
	},
	{
		question: 'Können Aufgaben individuell angepasst werden?',
		answer: 'Ja, jede Aufgabe kann flexibel auf eure Familienbedürfnisse angepasst, wiederkehrend geplant oder neu zugewiesen werden.',
	},
	{
		question: 'Gibt es Erinnerungen für fällige Aufgaben?',
		answer: 'Ja, Erledix sendet automatische Erinnerungen, damit keine Aufgabe vergessen wird – so hat man alles stressfrei im Griff',
	},
];

export const FaqSection = () => {
	const [activeIndex, setActiveIndex] = useState<number | null>(null);

	const toggle = (index: number) => {
		setActiveIndex(activeIndex === index ? null : index);
	};

	return (
		<section className='faq-section'>
			<h1 className='faq-title'>Häufige Fragen (FAQ)</h1>
			{faqItems.map((item, index) => (
				<div className='faq-item' key={index}>
					<button
						className='faq-question'
						onClick={() => toggle(index)}
						aria-expanded={activeIndex === index}
						aria-controls={`faq-answer-${index}`}
						id={`faq-question-${index}`}
					>
						{item.question}
					</button>
					{activeIndex === index && (
						<div
							id={`faq-answer-${index}`}
							role='region'
							aria-labelledby={`faq-question-${index}`}
							className='faq-answer'
						>
							{item.answer}
						</div>
					)}
				</div>
			))}
		</section>
	);
};
